import { useMemo } from 'react';
import { useAdminAccountSignedIn, useContentManagerAccountSignedIn, useUserSignedIn } from '../../api';

export enum LevelOfUser {
  User = 0,
  Admin = 2,
  ContentManagement = 1,
}

export const useLevelUserCheck = (level: LevelOfUser) => {
  const { isSignedIn: isUserSignedIn, isLoading: isLoadingUserSignIn } = useUserSignedIn();
  const { isSignedIn: isAdminAccountSignedIn, isLoading: isLoadingAdminAccountSignIn } = useAdminAccountSignedIn();
  const { isSignedIn: isContentAccountSignedIn, isLoading: isLoadingContentAccountSignIn } =
    useContentManagerAccountSignedIn();

  return useMemo(() => {
    const userLevel = [
      {
        level: LevelOfUser.User,
        status: isUserSignedIn,
        isLoading: isLoadingUserSignIn,
      },
      {
        level: LevelOfUser.ContentManagement,
        status: isContentAccountSignedIn,
        isLoading: isLoadingContentAccountSignIn,
      },
      {
        level: LevelOfUser.Admin,
        status: isAdminAccountSignedIn,
        isLoading: isLoadingAdminAccountSignIn,
      },
    ];

    let finalStatus = { status: false, highestLevel: LevelOfUser.User, isLoading: false };
    for (const { level: currentLevel, status, isLoading } of userLevel) {
      if (status) {
        finalStatus = { status, highestLevel: currentLevel, isLoading };
      }
    }

    return finalStatus;
  }, [
    isUserSignedIn,
    isContentAccountSignedIn,
    isAdminAccountSignedIn,
    level,
    isLoadingUserSignIn,
    isLoadingContentAccountSignIn,
    isLoadingAdminAccountSignIn,
  ]);
};
